import _ from 'lodash'
// 全屏
const fullscreenMixin = {
  data () {
    return {
      isFullScreen: false
    }
  },
  methods: {
    fullscreenchange () {
      document.addEventListener('fullscreenchange', () => { this.isFullScreen = !!document.fullscreenEnabled })
      document.addEventListener('mozfullscreenchange', () => { this.isFullScreen = !!window.fullScreen })
      document.addEventListener('MSFullscreenChange', () => { this.isFullScreen = !!document.msFullscreenEnabled })
      document.addEventListener('webkitfullscreenchange', () => { this.isFullScreen = !!document.webkitIsFullScreen })
    },
    toggleFullScreen () {
      let element = document.documentElement
      if (this.isFullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen()
        }
      }
      document.getElementsByClassName('menuHide')[0].click()
    }
  }
}

// 全局的数据源报表
const dataSourceReport = {
  computed: {
    getDataSource () {
      let tables = this.formService.schema.getRelationTable('', this.formService.component.archive.tableId)
      tables.oneToManyTables.forEach(m => {
        m.type = 'OneToMany'
      })
      tables.oneToOneTables.forEach(m => {
        m.type = 'OneToOne'
      })
      return _.concat(tables.oneToOneTables, tables.oneToManyTables)
    }
  }
}
export { fullscreenMixin, dataSourceReport }



// WEBPACK FOOTER //
// ./src/components/shared/designMixins/mixins.js